var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinjaIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1806_109270)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DDDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0011 5.99797C12.6744 5.99797 9.7044 6.9313 7.74773 8.7913C7.66107 8.67797 7.58773 8.57797 7.54107 8.50464C7.2444 8.03464 6.90107 7.48464 6.65107 6.92797C6.6044 6.82464 6.5644 6.72797 6.53107 6.63797C6.74773 6.6913 7.0044 6.72797 7.2844 6.7113C7.55107 6.69464 7.8344 6.60464 8.09107 6.4113C8.3344 6.22797 8.47773 6.00797 8.55773 5.83464C8.70773 5.51464 8.72107 5.19797 8.72107 5.00464C8.72107 4.58464 8.61773 4.0913 8.50107 3.64464C8.26107 2.71797 7.78773 -0.628698 7.49773 -1.33203L5.3844 1.92797C5.62107 2.50464 5.92773 3.32797 6.13773 4.05797C6.08773 4.04797 6.03773 4.03797 5.9844 4.03464C5.78773 4.0113 5.49773 4.00464 5.1744 4.1213C4.38773 4.40464 4.13107 5.1013 4.05107 5.53464C3.88773 6.42464 4.1944 7.3213 4.49107 7.9813C4.80107 8.6713 5.1144 8.93797 5.1144 8.93797L5.97107 9.92797L6.48773 10.388C6.07773 11.068 5.76107 11.8246 5.57107 12.6646C5.1344 12.4413 4.62107 12.178 4.1744 11.8846C4.09107 11.8313 4.0144 11.778 3.9444 11.7246C4.12107 11.6913 4.32107 11.6346 4.5044 11.5313C4.68107 11.4346 4.8344 11.2813 4.91773 11.068C4.99773 10.8646 4.98773 10.6713 4.95773 10.5246C4.9044 10.258 4.75773 10.038 4.66107 9.90797C4.45107 9.62464 4.13773 9.3213 3.83773 9.05797C3.2144 8.50797 1.22773 6.38797 0.677734 6.00464L0.817734 8.89797C1.26773 9.21464 1.88773 9.6713 2.3944 10.1013C2.3544 10.1113 2.3144 10.1213 2.2744 10.1346C2.1244 10.1813 1.92107 10.2713 1.7544 10.4546C1.34773 10.9013 1.5144 11.458 1.67107 11.7746C1.99773 12.4313 2.6544 12.9413 3.18773 13.2913C3.7444 13.658 4.0944 13.738 4.0944 13.738L5.18107 14.1313L5.3744 14.178C5.3644 14.3713 5.3444 14.5613 5.3444 14.7646C5.3444 20.608 10.1211 26.668 16.0111 26.668C21.9011 26.668 26.6777 20.608 26.6777 14.7646C26.6777 8.9213 21.9011 6.0013 16.0111 6.0013L16.0011 5.99797Z",
    fill: "url(#paint0_linear_1806_109270)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M8.58667 21.668C7.25 19.7713 6.45 17.458 6.45 15.1813C6.45 9.9013 10.75 7.26464 16.0533 7.26464C19.3567 7.26464 22.2733 8.28797 24 10.338C22.36 7.8913 19.2133 6.66797 15.6033 6.66797C10.3 6.66797 6 9.30464 6 14.5846C6 17.108 6.98333 19.6746 8.58667 21.668Z",
    fill: "#E8EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8327 15.0506C24.8327 18.8706 20.4927 22.6673 15.9993 22.6673C11.506 22.6673 7.16602 18.8706 7.16602 15.0506C7.16602 11.2306 11.506 12.0806 15.9993 12.0806C20.4927 12.0806 24.8327 11.234 24.8327 15.0506Z",
    fill: "url(#paint1_linear_1806_109270)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2278 15.2786C23.6011 16.2319 22.8144 17.3686 21.4711 17.8153C20.1278 18.2653 18.7344 17.8553 18.3578 16.9019C17.9844 15.9486 18.7378 15.5553 20.0811 15.1053C21.4244 14.6553 22.8511 14.3253 23.2278 15.2786ZM8.77444 15.2786C8.40111 16.2319 9.18778 17.3686 10.5311 17.8153C11.8744 18.2653 13.2678 17.8553 13.6444 16.9019C14.0178 15.9486 13.2644 15.5553 11.9211 15.1053C10.5778 14.6553 9.15111 14.3253 8.77444 15.2786Z",
    fill: "url(#paint2_linear_1806_109270)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1806_109270",
    x1: 24.3044,
    y1: 23.818,
    x2: 3.78107,
    y2: 3.29464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1E282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#343E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8E9496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EAEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1806_109270",
    x1: 15.2927,
    y1: 11.7273,
    x2: 17.566,
    y2: 22.5873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7E9EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919EA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1806_109270",
    x1: 8.80988,
    y1: 14.9216,
    x2: 23.0502,
    y2: 17.4325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A74FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1806_109270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaIconLight);
export default __webpack_public_path__ + "static/media/ninja-icon-light.62e82be8d716d2571c701c277389e5af.svg";
export { ForwardRef as ReactComponent };